module.exports = __webpack_public_path__ + "static/media/plastic.e7434871.png";